import React, { useState, useRef, useEffect } from "react";
import pdf from "../../../assets/images/pdf.webp";
import prnt from "../../../assets/images/print.png";
import whtaapp from "../../../assets/images/whatsapp.webp";

const HamburgerMenu = ({ 
  onPrint, 
  onDownloadPDF, 
  onSendWhatsApp, 
  onClose,
  loading = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleAction = (action) => {
    action();
    setIsOpen(false);
  };

  // SVG Menu Icon (Hamburger)
  const MenuIcon = () => (
    <svg 
      className="w-6 h-6" 
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={2} 
        d="M4 6h16M4 12h16M4 18h16" 
      />
    </svg>
  );

  // SVG Close Icon (X)
  const CloseIcon = () => (
    <svg 
      className="w-6 h-6" 
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={2} 
        d="M6 18L18 6M6 6l12 12" 
      />
    </svg>
  );

  // SVG Close Icon for Close Button (smaller)
  const CloseButtonIcon = () => (
    <svg 
      className="w-5 h-5" 
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={2} 
        d="M6 18L18 6M6 6l12 12" 
      />
    </svg>
  );

  return (
    <div className="relative" ref={menuRef} >
      {/* Hamburger Icon Button */}
      <button
        className="w-10 h-10 flex items-center justify-center bg-transparent border-none border-gray-400 rounded-lg z-50 hover:bg-gray-50 transition-colors"
        onClick={toggleMenu}
        style={{ position: "relative", zIndex: 1001 }}
        aria-label={isOpen ? "Close menu" : "Open menu"}
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </button>

      {/* Menu Dropdown */}
      <div
        className={`absolute right-0 top-12 w-auto bg-white rounded-lg shadow-lg border border-gray-200 transition-all duration-300 ease-in-out z-50 ${
          isOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4 pointer-events-none"
        }`}
      >
        <div className="p-3 space-y-3">
         

          {/* PDF Button */}
          <button
            className="w-auto flex items-center justify-start p-3 bg-blue-500  rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => handleAction(onDownloadPDF)}
            disabled={loading}
            aria-label="Download PDF"
          >
            <img src={pdf} alt="PDF" className="w-5 h-5" />
            {/* <span className="ml-2">Download PDF</span> */}
          </button>

          {/* Print Button */}
          <button
            className="w-auto flex items-center justify-start p-3 bg-green-500  rounded-lg hover:bg-green-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => handleAction(onPrint)}
            disabled={loading}
            aria-label="Print receipt"
          >
            <img src={prnt} alt="Print" className="w-5 h-5" />
            {/* <span className="ml-2">Print</span> */}
          </button>

          {/* WhatsApp Button */}
          <button
            className="w-auto flex items-center justify-start p-3 bg-green-600  rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => handleAction(onSendWhatsApp)}
            disabled={loading}
            aria-label="Send via WhatsApp"
          >
            <img src={whtaapp} alt="WhatsApp" className="w-5 h-5" />
            {/* <span className="ml-2">{loading ? "Sending..." : "Send via WhatsApp"}</span> */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenu;